import React from "react"

import { useLanguage } from "@/lib/language-context";
import { useApp, type AppScreen } from "@/lib/app-context";
import { FileSearch, Phone } from "lucide-react";

export function BottomNav() {
  const { t } = useLanguage();
  const { currentScreen, setCurrentScreen } = useApp();

  const isActive = (screen: AppScreen | AppScreen[]) => {
    if (Array.isArray(screen)) {
      return screen.includes(currentScreen);
    }
    return currentScreen === screen;
  };

  const navItemClass = (screen: AppScreen | AppScreen[]) =>
    `flex flex-col items-center gap-1 p-2 transition-colors ${
      isActive(screen) ? "text-primary" : "text-muted-foreground hover:text-primary"
    }`;

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // Use location.href for WhatsApp - more reliable across environments
    window.location.href = `https://wa.me/${t.phoneNumberRaw}`;
  };

  return (
    <nav className="sticky bottom-0 bg-card border-t border-border safe-area-inset-bottom z-50">
      <div className="flex justify-around py-2">
        <button
          onClick={() => setCurrentScreen("home")}
          className={navItemClass("home")}
          aria-label={t.home}
        >
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          <span className="text-xs font-medium">{t.home}</span>
        </button>

        <button
          onClick={() => setCurrentScreen("status")}
          className={navItemClass("status")}
          aria-label={t.status}
        >
          <FileSearch className="h-6 w-6" />
          <span className="text-xs font-medium">{t.status}</span>
        </button>

        <button
          onClick={() => setCurrentScreen("faq")}
          className={navItemClass("faq")}
          aria-label={t.faq}
        >
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-xs font-medium">{t.faq}</span>
        </button>

        <button
          onClick={handleContactClick}
          className="flex flex-col items-center gap-1 p-2 text-muted-foreground hover:text-primary transition-colors"
          aria-label={t.contact}
        >
          <Phone className="h-6 w-6" />
          <span className="text-xs font-medium">{t.contact}</span>
        </button>
      </div>
    </nav>
  );
}
